import instance from "./axios";
import {
  StringSize,
  DefectType,
  CellyieldRequest,
  CellyieldResponse,
  CellyieldData,
  CellyieldDeleteParams,
} from "../types/stringerTypes";

export const defectTypeIdMap: Record<DefectType, number> = {
  Zellbruch: 78,
  "Ribbon-Shiftt": 79,
  "Schlechte Lötung": 80,
  Zellabstand: 81,
  Verschmutzung: 82,
  Peeltest: 83,
};

const STATION_ID = 22;

export const addCellyield = async (
  payload: CellyieldRequest
): Promise<CellyieldResponse> => {
  const res = await instance.post<CellyieldResponse>(
    "/v1.0/Cellyield/AddCellyield",
    payload
  );
  return res.data;
};

export const deleteCellyield = async (
  params: CellyieldDeleteParams
): Promise<CellyieldResponse> => {
  const res = await instance.delete<CellyieldResponse>(
    "/v1.0/Cellyield/DeleteCellyield",
    {
      params: {
        defectTypeId: params.defectTypeId,
        stationId: params.stationId,
        stringerType: params.stringType,
      },
    }
  );
  return res.data;
};

export const getLatestCellyieldsFromSixAM = async (): Promise<
  CellyieldData[]
> => {
  const res = await instance.get<CellyieldData[]>(
    "/v1.0/Cellyield/GetLatestCellyieldFromSixAM"
  );
  return res.data;
};

export const createCellyieldPayload = (
  defectType: DefectType,
  stringSize: StringSize
): CellyieldRequest => ({
  defectTypeId: defectTypeIdMap[defectType],
  stationId: STATION_ID,
  stringType: stringSize,
});
